import Box from '@mui/material/Box';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(Box)`
  width: 100%;
  background-color: rgba(0, 83, 42, 0.1);
  border-radius: 4px;
  .title {
    font-family: 'Lanna';
    color: ${(props: any) => props.theme.palette.secondary.light};
    font-size: 18px;
    font-weight: normal;
  }
  .description {
    font-size: 18px;
    font-weight: normal;
  }
`);
